import script from "./AuthFormTg.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuthFormTg.vue?vue&type=script&setup=true&lang=ts"

import "./AuthFormTg.vue?vue&type=style&index=0&id=291dbc28&lang=scss&scoped=true"

import exportComponent from "/home/dima/Work/pioneer-lk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-291dbc28"]])

export default __exports__